import '../css/style.css';
import jobs from '../data/opening-jobs.js';

console.log('Job Board Initialized');

function renderJobs() {
    const jobContainer = document.getElementById('job-list-container');
    if (!jobContainer) return;

    jobContainer.innerHTML = jobs.map(job => {
        const tagsHtml = job.tags.map(tag => `<span class="tech-tag">${tag}</span>`).join('');
        const requirementsHtml = job.requirements.map(req => `<li>${req}</li>`).join('');
        
        // Construct Mailto Link
        const mailSubject = encodeURIComponent(`Application: ${job.title} (${job.id})`);
        const mailBody = encodeURIComponent(`Hi Jumpex Team,

I am interested in the ${job.title} position.

[Please attach your resume and GitHub link here]

Best,
`);
        const mailtoLink = `mailto:hr@jumpex.io?subject=${mailSubject}&body=${mailBody}`;

        return `
            <div class="job-card neon-card">
                <div class="job-header">
                    <h2 class="job-title">${job.title}</h2>
                    <div class="job-meta">
                        <span class="location">📍 ${job.location}</span>
                        <span class="type">💼 ${job.type}</span>
                    </div>
                </div>
                
                <div class="job-tags">
                    ${tagsHtml}
                </div>

                <div class="job-body">
                    <p class="description">${job.description}</p>
                    <div class="requirements">
                        <h4>Requirements:</h4>
                        <ul>
                            ${requirementsHtml}
                        </ul>
                    </div>
                </div>

                <div class="card-footer">
                    <span class="job-date">Updated: ${job.updated_at}</span>
                    <a href="${mailtoLink}" class="btn-neon btn-sm">Apply via Email</a>
                </div>
            </div>
        `;
    }).join('');
}

document.addEventListener('DOMContentLoaded', renderJobs);
